$(document).ready(function () {
	$(function(){

	    var url = window.location.pathname,
	        urlRegExp = new RegExp(url.replace(/\/$/,'') + "$"); // create regexp to match current url pathname and remove trailing slash if present as it could collide with the link in navigation in case trailing slash wasn't present there
	        // now grab every link from the navigation
	        $('.topMenu__menu-item a').each(function(){
	            // and test its normalized href against the url pathname regexp
	            if(urlRegExp.test(this.href.replace(/\/$/,''))){
	                $(this).addClass('active');
	            }
	        });
				if(window.location.pathname == '/'){
						$('.topMenu__menu-item a').removeClass('active');
				}

	});
  $('.js-slider').owlCarousel({
    loop: false,
    margin: 0,
    nav: true,
    dots: true,
    items: 1,
    autoplay: true,
    autoplayTimeout: 7000,
    smartSpeed: 2000,
    dotsContainer: '.js-slider__dots',
    animateOut: 'fadeOut',
    onInitialized  : counter, //When the plugin has initialized.
    onTranslated : counter //When the translation of the stage has finished.
  });

    function counter(event) {
        var element   = event.target;
         var items     = event.item.count;
         var item      = event.item.index + 1;
       $('.js-slider__number-item').text(item);
     }

		$('.partners-carousel').owlCarousel({
        loop: true,
        margin:0,
        nav:true,
				autoplay: true,
				autoplayTimeout: 4000,
        dots: false,
        responsive:{
            0:{
                items:1
            },
            600:{
                items:3
            },
            1000:{
                items:5
            }
        }
    });

    var scrollToElem = function(eventElem, scrollToElem,time) {
        $(eventElem).on('click', function(){
            $('html, body').animate({
                scrollTop: $(scrollToElem).offset().top
            }, time);
        });
    };
    // contact page - scroll to map
    scrollToElem('.js-sideInfo__map','.contactPage__map',750);

    //js-up

    $(".js-up").on("click", function () {
        var body = $("html, body");
        body.stop().animate({scrollTop: 0}, 1500, 'swing');
    });
    $(window).on("scroll", function () {
        var scroll = $(window).scrollTop();
        if (scroll > 900) {
            $(".js-up").addClass("visible");
        } else {
            $(".js-up").removeClass("visible");
        }
    });

    // contrast

    $('.js-contrast__item--light').on('click',function(){
        $(this).addClass('contrast__item--active');
        $('.js-contrast__item--dark').removeClass('contrast__item--active');

        $('.page').toggleClass('page--light').removeClass('page--dark');
        Cookies.set('contrast', 'page--light', {expires: 12});
        if ($('.page--light').length) {
            Cookies.set('contrast', 'page--light', {expires: 12});
        } else {
            Cookies.remove('contrast');
        }
        var pageColor = Cookies.get('contrast');

    });
    $('.js-contrast__item--dark').on('click',function(){
        $(this).addClass('contrast__item--active');
        $('.js-contrast__item--light').removeClass('contrast__item--active');
        $('.page').toggleClass('page--dark').removeClass('page--light');
        if ($('.page--dark').length) {
            Cookies.set('contrast', 'page--dark', {expires: 12});
        } else {
            Cookies.remove('contrast');
        }

    });
    var pageColor = Cookies.get('contrast');
        if (pageColor === 'page--light') {
            $('.page').addClass('page--light');
            $('.js-contrast__item--light').addClass('contrast__item--active');
            $('.js-contrast__item--dark').removeClass('contrast__item--active');
        } else if (pageColor === 'page--dark') {
            $('.page').addClass('page--dark');
            $('.js-contrast__item--light').removeClass('contrast__item--active');
            $('.js-contrast__item--dark').addClass('contrast__item--active');
        } else {
            $('.page').removeClass('page--dark, page--light');
            $('.js-contrast__item--light,.js-contrast__item--dark').removeClass('contrast__item--active');
        }
   //show search input
    $('.search__icon').on('click',function(){
        $(this).next('.nav').toggleClass('nav--visible');
    });
 //font-size changing

    $('.js-textSize__item--big').on('click',function(){
        $('.page').addClass('page--big').removeClass('page--middle');
        if ($('.page--big').length) {
            Cookies.set('fontsize', 'page--big', {expires: 12});
        } else {
            Cookies.remove('fontsize');
        }
    });

    $('.js-textSize__item--middle').on('click',function(){
        $('.page').addClass('page--middle').removeClass('page--big');
        if ($('.page--middle').length) {
            Cookies.set('fontsize', 'page--middle', {expires: 12});
        } else {
            Cookies.remove('fontsize');
        }

    });
    $('.js-textSize__item--small').on('click',function(){
        $('.page').removeClass('page--middle').removeClass('page--big');
        Cookies.remove('fontsize');

    });
    var fontSize = Cookies.get('fontsize');
        if (fontSize === 'page--big') {
            $('.page').addClass('page--big');
        } else if (fontSize === 'page--middle') {
            $('.page').addClass('page--middle');
        } else {
            $('.page').removeClass('page--big, page--middle');
        }

        //load front news
        // $('.js-button--front').click(function(){
        //     $('.oneNews').css('display','flex');
        //     $(this).hide();
        // });

});
